document.addEventListener('DOMContentLoaded', function() {
  const storedUrl = localStorage.getItem('targetUrl');
  if (storedUrl) {
    const listItems = document.querySelectorAll('.has-dropdown');
     const logoLink = document.querySelector('.medium-down--hide .header-logo')
    const isValidUrl = (url) => {
      try {
          new URL(url); // This will throw an error if the URL is invalid
          return true;
      } catch (e) {
          return false;
      }
  };
  const finalUrl = isValidUrl(storedUrl);
    logoLink.href = storedUrl
  
    listItems.forEach(item => {
      const links = Array.from(item.children).filter(child => 
        child.tagName === 'A' && child.getAttribute('href') === storedUrl
      );
  
      if (links.length > 0) {
        Array.from(document.querySelectorAll('.main-menu-item')).forEach(
          (el) => el.classList.remove('is-open')
        );
        item.classList.add('is-open');
      }
    });
  } else {
    const listItems = document.querySelectorAll('.default--1');
      listItems.forEach(item => {
      item.classList.add('is-open');
    });
  }
  
  const openDropdown = document.querySelector('.has-dropdown.is-open');
  if (openDropdown) {
      document.body.classList.add('main-menu-open');
  }
  /*if(window.location.href === "https://ivalo.com/" || window.location.href === "https://fi.ivalo.com/" || window.location.href === "https://nl.ivalo.com/" ){
      try {
        const storedUrl = localStorage.getItem('targetUrl');
        if (storedUrl) {
          window.location.href = storedUrl;
        }
      } catch (e) {
        console.error('Error accessing localStorage:', e);
      }
    }*/
    const menuLinks = document.querySelectorAll('.has-dropdown>.menu-link-fix');

    if (menuLinks.length > 0) {
        menuLinks.forEach(menuLink => {
          menuLink.addEventListener('click', function(event) {
            event.preventDefault();
            const targetUrl = this.getAttribute('href');
            try {
              localStorage.setItem('targetUrl', targetUrl);
            } catch (e) {
              console.error('Error setting localStorage:', e);
            }
            window.location.href = targetUrl;
            const savedUrl = localStorage.getItem('savedUrl');
          });
        });
    } else {
      console.error('No elements with class "menu-link-fix has-dropdown" found.');
    }
});